import { Phone, EnvelopeSimple, MapPin, FacebookLogo } from "@phosphor-icons/react";
import { PHONE, PHONE_TEL, EMAIL, FACEBOOK_URL } from "@/lib/siteData";
import { CITIES } from "@/lib/cities";

const QUICK = [
  { label: "General Contracting", href: "/services/general-contracting" },
  { label: "Remodeling", href: "/services/home-remodeling" },
  { label: "HVAC", href: "/services/hvac" },
  { label: "Painting", href: "/services/painting" },
  { label: "Fencing", href: "/services/fence-building" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink border-t border-line pt-16 pb-8">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-4">
              <span className="bg-white rounded-md p-1.5 flex items-center justify-center">
                <img src="/logo-white.png" alt="B3 Contracting LLC logo" className="h-20 w-auto object-contain" />
              </span>
            </div>
            <p className="mt-5 font-heading text-gold text-lg tracking-tight">
              Building It Right. From the Ground Up.
            </p>
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              aria-label="B3 Contracting on Facebook"
              className="mt-6 inline-flex items-center justify-center h-11 w-11 border border-line text-white/70 hover:text-gold hover:border-gold transition-colors"
            >
              <FacebookLogo size={22} weight="fill" />
            </a>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5">Quick Links</p>
            <ul className="space-y-3">
              {QUICK.map((q) => (
                <li key={q.label}>
                  <a
                    href={q.href}
                    data-testid={`footer-link-${q.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-white/70 hover:text-gold transition-colors"
                  >
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5">Get In Touch</p>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone" className="flex items-center gap-3 text-white/80 hover:text-gold transition-colors">
                  <Phone weight="fill" size={18} className="text-gold" />
                  {PHONE}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="flex items-center gap-3 text-white/80 hover:text-gold transition-colors break-all">
                  <EnvelopeSimple weight="fill" size={18} className="text-gold shrink-0" />
                  {EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin weight="fill" size={18} className="text-gold shrink-0 mt-0.5" />
                Schertz, New Braunfels, San Antonio &amp; surrounding areas
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-line">
          <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">Areas We Serve</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
            {CITIES.map((c) => (
              <a key={c.slug} href={`/contractor/${c.slug}`} data-testid={`footer-city-${c.slug}`} className="text-white/60 hover:text-gold transition-colors">
                Contractor in {c.city}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">© {new Date().getFullYear()} B3 Contracting LLC. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href={`tel:${PHONE_TEL}`} className="text-sm text-white/50 hover:text-gold transition-colors">
              Free estimates · {PHONE}
            </a>
            <a href="/admin/login" data-testid="footer-admin-login" className="text-sm text-white/40 hover:text-gold transition-colors">
              Owner Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
